import React from "react";
import { Route } from "react-router-dom";
import TransferPropertyForm from "../../../pages/Views/OperationAndManagement/Forms/TransferPropertyForm";
import ParcelList from "../../../pages/Views/Shared/Report/List/ParcelList";
import RegisterInvestorActivities from "../../../pages/Views/OperationAndManagement/Forms/RegisterInvestorActivities";
import InvestorList from "../../../pages/Views/Shared/Report/List/InvestorList";
import InvAftercareReport from "../../../pages/Views/OperationAndManagement/Reports/InvAftercareReport";
import ImportExistingTenant from "../../../pages/Views/OperationAndManagement/Forms/ImportExistingTenant";
import InvAftercareSettings from "../../../pages/Views/OperationAndManagement/Forms/InvAftercareSettings";
//*************New import****** */
import AgreementVerificationPage from "../../../pages/Views/OperationAndManagement/Forms/AgreementVerificationPage"; 
import TerminationVerification from "../../../pages/Views/OperationAndManagement/Forms/TerminationVerification.jsx"; 
import NewInvestorVerification from "../../../pages/Views/OperationAndManagement/Forms/NewInvestorVerification.jsx"; 
import RenewAgreement from "../../../pages/Views/OperationAndManagement/Forms/RenewalVerificationPage"; 
//****************** */
import OperationHeadDashboard from "../../../pages/Views/OperationAndManagement/OperationHeadDashboard";
import Leased_rate from "../../../pages/Views/OperationAndManagement/Forms/Leased_rate";
// import Charts from "../../../pages/Views/OperationAndManagement/Forms/Charts";
import ViewMapByCategoryPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views/ViewMapByCategoryPage";
//import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
import { ParksDetailByOccupancy, ParksDetailBySector } from "../../../pages/Views/ExecutiveView/DashboardDetail";
import { FinancialSummaryReport } from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import AgreementManagementPage from "../../../pages/Views/OperationAndManagement/Forms/AgreementManagementPage";
import InvestorAfterCareReport2 from "../../../pages/Views/OperationAndManagement/Reports/InvestorAfterCareReport2";
import EmploymentReport from "../../../pages/Views/OperationAndManagement/Reports/EmploymentReport";
import TradeReport from "../../../pages/Views/OperationAndManagement/Reports/TradeReport";
import ParcelListAll from "../../../pages/Views/Shared/Report/List/ParcelListAll";
import InvestorListAll from "../../../pages/Views/Shared/Report/List/InvestorListAll";
export default function OperationManagementHeadRoutes() {
  return (
    <>
      {/* <Route path="/" element={<OperationManagementHeadRoutes />} /> */}
      <Route path="/employment" element={<EmploymentReport />} />
      <Route path="/tradereport" element={<TradeReport />} />
      <Route path="/investorReport" element={<InvestorAfterCareReport2 />} />
      <Route path="/" element={<OperationHeadDashboard />} />
      <Route path="/investorActivities" element={<RegisterInvestorActivities />} />
      <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
      <Route path="/investorList" element={<InvestorList />} />
      
      <Route path="/investorList" element={<InvestorListAll />} />
      <Route path="/agreementList" element={<AgreementManagementPage />} />
      <Route path="/parcelList" element={<ParcelListAll />} />

      <Route path="/importTenant" element={<ImportExistingTenant />} />
      <Route path="/invAftercareReport" element={<InvAftercareReport />} />
      {/* ************ */}
      <Route path="/verifyAggrement" element={<AgreementVerificationPage />} /> 
      <Route path="verfyRenewalRequest" element={<RenewAgreement />} />
      <Route path="/verifyInvestor" element={<NewInvestorVerification />} />
      <Route path="/verifyTerminationRequest" element={<TerminationVerification />} />
      {/* <Route path="/charts" element={<Charts />} /> */}
      {/* ************ */}
      
      <Route path="/leaseRateTable" element={<Leased_rate />} />
      <Route path="/invAftercareSettings" element={<InvAftercareSettings />} />
      <Route path="/transferProperty" element={<TransferPropertyForm />} />
      <Route path="/parksByOccupancy" element={<ParksDetailByOccupancy />} />
      <Route path="/parksByIndustry" element={<ParksDetailBySector />} />
      <Route path="/financeSummary" element={<FinancialSummaryReport />} />
      <Route path="/agreementList" element={<AgreementManagementPage />} />
    </>
  );
}
